var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "included", class: { _open: _setup.isOpen } },
    [
      _c(
        "div",
        { staticClass: "included__header", on: { click: _setup.toggle } },
        [
          _c(
            "div",
            {
              staticClass: "included__badge",
              class: { [_setup.props.iconClass]: _setup.props.iconClass },
            },
            [
              _c(_setup.icon_comp(_setup.props.icon), {
                tag: "component",
                staticClass: "included__badge-icon",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "included__title" }, [
            _vm._v("\n      " + _vm._s(_setup.props.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c(_setup.vDown, {
            staticClass: "included__icon vicon-black",
            class: { _open: _setup.isOpen },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "included__content" },
        [
          _c(
            _setup.InsertHtml,
            _vm._b(
              { staticClass: "included__html" },
              "InsertHtml",
              _setup.props.included,
              false
            )
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }